import axios from "axios";

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service workers are not supported by this browser.");
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.error("SW registration failed: ", registrationError);
      });
  });
}

export function checkNotificationStatus() {
  if (!("Notification" in window)) {
    console.warn("Notifications are not supported by this browser.");
    return "unsupported";
  }

  return Notification.permission;
}

export async function subscribeToPushNotifications(vapidPublicKey) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.warn("Push notifications are not supported by this browser.");
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidPublicKey,
      });
    }
    await sendPushSubscriptionToServer(subscription);
  } catch (error) {
    console.error("Failed to subscribe user to push notifications: ", error);
  }
}

async function sendPushSubscriptionToServer(subscription) {
  await axios.post("/jwt_sessions/save_subscription", {
    subscription: subscription,
  });
}
